import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import GlobalFilterPanel, { FILTER_PERIOD_GROUP } from '../../filter/GlobalFilterPanel';
import DataMiningCommonFilterPanel from '../DataMiningCommonFilterPanel';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

import Logger, { LOG_LEVELS } from '../../../utils/log';
const log = new Logger('DATA_MINING_SII_TRANSACTIONS_FILTER_PANEL', LOG_LEVELS.DEBUG);

const DEFAULT_FILTER_SETTING = {
    filterPeriodGroup: FILTER_PERIOD_GROUP.DATE_RANGE,
    fieldOptions: {},
    hideElements: {
        month: true,
        year: true,
        countryCode: true,
        companyId: true,
        returnType: true,
        returnStatus: true
    },
    adaptPeriodOptions : {
      customDateRangeProvider: (selection) => {
        let customDateRange = {};
        let selectionEndDate = selection.endDate ? moment.utc(selection.endDate) : moment.utc(new Date());
        customDateRange.endDate = selectionEndDate;
        customDateRange.startDate = moment.utc(selectionEndDate).subtract('1', 'month');
        return customDateRange;
      }
    }
};

export class SiiTransactionsFilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'SII transactions',
                dateType: 'transaction',
                startDate: '',
                endDate: '',
                sortAscending: false
            },
            filterSetting: DEFAULT_FILTER_SETTING
        };
        this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
        this.dateTypeInputHandler = this.dateTypeInputHandler.bind(this);
        this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);
        this.props.onReportTypeChange(selection);
    }

    dateTypeInputHandler(evt) {
        let selection = Object.assign({}, this.state.selection, { dateType: evt.target.value });
        log.debug('dateTypeInputHandler: ', selection);
        this.setState({ selection: selection });
    }

    onCheckboxChangeHandler(evt) {
        let selection = Object.assign({}, this.state.selection);
        selection.sortAscending = !evt.target.checked;
        this.setState({
            selection: selection
        });
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
        log.debug('onSearchClickHandler(): selection: ', selection);
        let existingSelection = Object.assign({}, this.state.selection);
        existingSelection.startDate = selection.startDate;
        existingSelection.endDate = selection.endDate;
        this.props.onSearchClick(existingSelection);
    }

    render() {
        log.debug('render() - props: ', this.props);
        let selection = this.state.selection || {};
        const filterSetting = this.state.filterSetting || DEFAULT_FILTER_SETTING;

        return (
            <div>
                <s-box name="filter-panel">
                    <GlobalFilterPanel
                        {...filterSetting}
                        onSearchClick={this.onSearchClickHandler}>

                        <DataMiningCommonFilterPanel
                            reportType={this.state.selection.reportType}
                            onReportTypeChange={this.onReportChangeHandler}
                        />
                      <fieldset>
                        <legend><LanguageStringResolver string='dataMining_SiiTransactions_SortByReportingDate' /></legend>
                        <span className="clear"></span>
                        <input
                          type="checkbox"
                          onChange={this.onCheckboxChangeHandler}
                          name="siiTransactionsSortByEventCreated"
                          checked={!selection.sortAscending}
                        />
                        <label className="checkbox"><LanguageStringResolver string='dataMining_SiiTransactions_Descending' /></label>
                      </fieldset>
                    </GlobalFilterPanel>
                    <div className="clear"></div>
                </s-box>
            </div>
        );
    }
}


SiiTransactionsFilterPanel.defaultProps = {
    onReportTypeChange: () => { },
    onSearchClick: () => { }
};

function mapStateToProps(state) {
    return {}
}

function mapDispatchersToProps(dispatch) {
  return {}
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(SiiTransactionsFilterPanel);